
// import '~/plugins/CardGroup.js'
export default {
  name: 'IntSlides',
  props: {
    showText: {
      type: Boolean,
      required: true
    },
    slides: {
      type: Array,
      required: true
    },
    video: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      reload: true,
      intSlides: null,
      intSlidesGuides: null,
      scrollLeft: null
      // slides: [
      //   {
      //     title: 'Grass'
      //   },
      //   {
      //     title: 'Grass'
      //   },
      //   {
      //     title: 'Ivy Walls'
      //   }
      // ]
    }
  },
  mounted () {
    this.intSlides = this.$el.querySelector('.intSlides .con-slides')
    this.intSlidesGuides = this.$el.querySelector('.intSlides .slides-guides')
    this.intSlidesCarousel()
  },
  methods: {
    showIIntSlide (ind) {
      this.scrollLeft = ind * this.intSlides.offsetWidth
      this.intSlides.scrollLeft = this.scrollLeft
      this.checkCurrentActiveSlide()
      this.reload = false
    },
    intSlidesCarousel () {
      const slides = this.intSlides
      setInterval(() => {
        if (this.reload) {
          this.scrollLeft = slides.scrollLeft === slides.scrollWidth - slides.offsetWidth ? 0 : slides.scrollLeft + slides.offsetWidth
          slides.scrollLeft = this.scrollLeft
          this.checkCurrentActiveSlide()
        }
      }, 5000)
    },
    updateScrollLeft () {
      this.scrollLeft = this.intSlides.scrollLeft
    },
    checkCurrentActiveSlide () {
      if (window.innerWidth < 500) {
        this.scrollLeft = this.intSlides.scrollLeft
      }
      const ind = Math.round(this.scrollLeft / this.intSlides.offsetWidth)
      Array.from(this.intSlidesGuides.children).forEach((elm) => {
        elm.classList.remove('active')
      })
      if (!isNaN(ind) && ind < this.intSlidesGuides.childElementCount) {
        this.intSlidesGuides.children[ind].classList.add('active')
      }
    }
  }
}
